import { forEach } from 'lodash';
import type { ComponentType, ReactElement } from 'react';
import { Component, createContext } from 'react';

import type { AuthUser } from '../auth/types';

export interface Analytics {
    initialize(user?: AuthUser);
    identifyUser(user: AuthUser);
    anonymousUser(pendoObj: string);
    clearSession();

    track(...e: any);
}

export class CIAnalytics {
    private static __instance: CIAnalytics = new CIAnalytics();

    public static getInstance(): CIAnalytics {
        return CIAnalytics.__instance;
    }

    private providers: Analytics[] = [];

    public initialize(user?: AuthUser): void {
        forEach(this.providers, (provider): void => provider.initialize(user));
    }

    public registerProvider(provider: Analytics): void {
        this.providers.push(provider);
    }

    public identifyUser(user: AuthUser): void {
        forEach(this.providers, (provider): void => provider.identifyUser(user));
    }
    public anonymousUser(pendoObj: string): void {
        forEach(this.providers, (provider): void => provider.anonymousUser(pendoObj));
    }

    public clearSession(): void {
        forEach(this.providers, (provider): void => provider.clearSession());
    }
}

export const AnalyticsContext = createContext(CIAnalytics);

export default function withAnalytics(WrappedComponent): ComponentType {
    return class extends Component {
        public render(): ReactElement {
            return (
                <AnalyticsContext.Provider value={CIAnalytics}>
                    <WrappedComponent></WrappedComponent>
                </AnalyticsContext.Provider>
            );
        }
    };
}
